import React from "react";
import { Box } from "@mui/material";
import GridSettingsComponent from "../chart/GridSettings";

const GridSettings = ({
  gridSize,
  onSizeChange,
  onCreateGrid,
  isGeneratingChart = false,
  inTheRound = false,
  onInTheRoundChange,
}) => {
  return (
    <Box className="p-4">
      <GridSettingsComponent
        gridSize={gridSize}
        onSizeChange={onSizeChange}
        onCreateGrid={onCreateGrid}
        isGeneratingChart={isGeneratingChart}
        inTheRound={inTheRound}
        onInTheRoundChange={onInTheRoundChange}
      />
    </Box>
  );
};

export default GridSettings;
